import React from 'react';

interface StatsCardProps {
	title: string;
	value: string | number;
	subtitle?: string;
	icon: React.ElementType;
	trend?: string;
	trendPositive?: boolean;
	status?: 'success' | 'warning' | 'error';
}

export const StatsCard: React.FC<StatsCardProps> = ({
	title,
	value,
	subtitle,
	icon: Icon,
	trend,
	trendPositive,
	status,
}) => {
	const getStatusColor = () => {
		switch (status) {
			case 'success':
				return 'text-green-600 bg-green-100';
			case 'warning':
				return 'text-yellow-600 bg-yellow-100';
			case 'error':
				return 'text-red-600 bg-red-100';
			default:
				return 'text-blue-600 bg-blue-100';
		}
	};

	return (
		<div className="bg-white rounded-xl border border-gray-200 p-6 hover:shadow-md transition-shadow">
			<div className="flex items-center justify-between">
				<div className="flex-1">
					<p className="text-sm font-medium text-gray-600">{title}</p>
					<p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
					{subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
					{trend && <p className={`text-sm mt-2 ${trendPositive ? 'text-green-600' : 'text-red-600'}`}>{trend}</p>}
				</div>
				<div className={`p-3 rounded-lg ${getStatusColor()}`}>
					<Icon className="h-6 w-6" />
				</div>
			</div>
		</div>
	);
};
